import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";

// Get all top-level app-config values, that are strings or bools, as env
// keys. Reading non-string/bool values this way is not supported and should
// be accessed by loading @nerdwallet/app-config directly.
var getEnvCompatibleAppConfig = function getEnvCompatibleAppConfig(appConfig) {
  return Object.keys(appConfig || {}).reduce(function (acc, key) {
    var value = appConfig[key];

    if (typeof value === 'string') {
      acc[key] = value;
    } else if (typeof value === 'boolean') {
      // transform false values into '' so they are actually falsey
      acc[key] = value === true ? 'true' : '';
    } else if (typeof value === 'number') {
      acc[key] = String(value);
    }

    return acc;
  }, {});
};

export default getEnvCompatibleAppConfig;